import * as React from "react"
import { Box } from "@mui/material"


export default function WrapperBlock({children, ...props}) {

    const { color='default', firstMoverDate=false, metric=null } = props

    const getColorLabel = type => ({
        'warn': 'warning.light',
        'info': 'info.main',
        'error': 'error.dark'
    })[type] || type

    return <Box sx={{
        color: getColorLabel(color),
        borderBottom: '1px solid',
        borderColor: 'divider',
        "&:last-of-type": {
            borderBottom: '0'
        },
        height: 32,
        display: 'flex',
        justifyContent: 'flex-end',
        fontWeight: 'bold',
        p: .5,
        ...props.sx
    }}>
        {children}
    </Box>
}